import { useAuth, useAuthCallback } from "@allergy123/auth-client/react";
import { AuthPanel, Button, Status } from "@allergy123/ui";
import { useNavigate } from "react-router";

/** Shared utility pages. The same three exist in every browser app (ADR 0010). */

export function AuthCallbackPage() {
  const navigate = useNavigate();
  const result = useAuthCallback((to) => navigate(to, { replace: true }));
  const { signIn } = useAuth();
  if (result.state === "error") {
    return (
      <AuthPanel logoVariant="auto" title="We couldn't finish signing you in">
        <p className="mb-4">The sign-in link may have expired or been used already. Start again and it should work.</p>
        <Status kind="error" label={result.error ?? "Sign-in failed"} className="mb-6 block" />
        <Button onClick={() => void signIn("/")}>Sign in again</Button>
      </AuthPanel>
    );
  }
  return (
    <AuthPanel logoVariant="auto" title="Signing you in">
      <p className="text-ink-secondary">One moment.</p>
    </AuthPanel>
  );
}

export function SignedOutPage() {
  const { signIn } = useAuth();
  return (
    <AuthPanel logoVariant="auto" title="You're signed out">
      <p className="mb-6">Your session has ended. Sign in again whenever you're ready to continue.</p>
      <Button onClick={() => void signIn("/")}>Sign in</Button>
    </AuthPanel>
  );
}

export function NoAccessPage() {
  const { session, signOut } = useAuth();
  return (
    <AuthPanel logoVariant="auto" title="This account doesn't have access here" footer={session?.claims.email ? `Signed in as ${session.claims.email}` : undefined}>
      <p className="mb-6">
        Your sign-in worked, but this account isn't set up for this product yet. If your practice is enrolled, ask your Allergy Program Manager or practice administrator to add
        you. Otherwise, contact Allergy 123 support.
      </p>
      <Button variant="secondary" surface="card" onClick={() => void signOut()}>
        Sign out
      </Button>
    </AuthPanel>
  );
}
